/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import SelectInput from "./SelectInput";

class BorderStyle extends Component {
	constructor(props) {
		super(props);
		let styles = ["solid", "dotted", "dashed"];
		let values = [];
		styles.forEach(style => {
			values.push({ key: style, value: style, label: style.toUpperCase() });
		});
		this.state = {
			values,
		};
	}

	render() {
		return (
			<div className="picker-input">
				{this.state.values && <SelectInput {...this.props} values={this.state.values} />}
			</div>
		);
	}
}

BorderStyle.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	apps: PropTypes.array,
	isRequired: PropTypes.bool,
};

export default BorderStyle;
